<template>

    <div class="preferences">
        <v-main>
            <v-container>
                <top-search-bar :mobile_number="mobile_number" :logo="logo" />

                <v-row>
                    <v-col cols="12" class="mb-3">
                        <p>Bill/ Invoice</p>
                        <hr>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <label for="">Customer Name
                            <span style="color:red">*</span>
                            <v-tooltip v-model="show" top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon color="grey lighten-1" style="font-size:18px">
                                            mdi-information
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Programmatic tooltip</span>
                            </v-tooltip>
                        </label>
                        <!-- <v-text-field prefix="" v-model="customer_name" outlined label="" placeholder="Customer Name">
                        </v-text-field> -->

                        <v-autocomplete v-model="select" :loading="loading" :items="items"
                                :search-input.sync="search" cache-items class="" flat hide-no-data hide-details
                                label="Customer Name" solo-inverted></v-autocomplete>
                        <!-- <v-toolbar>
                            <v-toolbar-title>State selection</v-toolbar-title>
                            <v-autocomplete v-model="select" :loading="loading" :items="items"
                                :search-input.sync="search" cache-items class="mx-4" flat hide-no-data hide-details
                                label="What state are you from?" solo-inverted></v-autocomplete>
                            <v-btn icon>
                                <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                        </v-toolbar> -->

                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6" lg="6" md="6" sm="12">
                        <label for="">Phone Number
                            <v-tooltip v-model="show" top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon color="grey lighten-1" style="font-size:18px">
                                            mdi-information
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Programmatic tooltip</span>
                            </v-tooltip>
                        </label>
                        <v-text-field prefix="" outlined label="" placeholder="Phone Number">
                        </v-text-field>
                    </v-col>
                    <v-col cols="6" lg="6" md="6" sm="12">
                        <label for="">Email
                            <v-tooltip v-model="show" top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon color="grey lighten-1" style="font-size:18px">
                                            mdi-information
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Programmatic tooltip</span>
                            </v-tooltip>
                        </label>
                        <v-text-field prefix="" outlined label="" placeholder="Email">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <label for="">Billing Address
                            <v-tooltip v-model="show" top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon color="grey lighten-1" style="font-size:18px">
                                            mdi-information
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Programmatic tooltip</span>
                            </v-tooltip>
                        </label>
                        <v-textarea outlined name="input-7-4" label="">
                        </v-textarea>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="6" lg="6" md="6" sm="12">
                        <label for="">PO No.
                            <v-tooltip v-model="show" top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon color="grey lighten-1" style="font-size:18px">
                                            mdi-information
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Programmatic tooltip</span>
                            </v-tooltip>
                        </label>
                        <v-text-field prefix="" outlined label="" placeholder="PO No.">
                        </v-text-field>
                    </v-col>
                    <v-col cols="6" lg="6" md="6" sm="12">
                        <label for="">PO Date
                            <v-tooltip v-model="show" top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon color="grey lighten-1" style="font-size:18px">
                                            mdi-information
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Programmatic tooltip</span>
                            </v-tooltip>
                        </label>
                        <v-text-field prefix="" outlined label="" placeholder="PO Date">
                        </v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="6">
                        <label for="">Opening Balance
                            <v-tooltip v-model="show" top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon color="grey lighten-1" style="font-size:18px">
                                            mdi-information
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Programmatic tooltip</span>
                            </v-tooltip>
                        </label>
                        <v-text-field prefix="" outlined label="" placeholder="Openinig Balance">
                        </v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="6">
                        <label for="">Payment Term Alert
                            <v-tooltip v-model="show" top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon color="grey lighten-1" style="font-size:18px">
                                            mdi-information
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Programmatic tooltip</span>
                            </v-tooltip>
                        </label>
                        <v-text-field prefix="" outlined label="" placeholder="Payment Term Alert">
                        </v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="6">
                        <label for="">Send Invoice by SMS/ Whatsapp/ Email
                            <v-tooltip v-model="show" top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon color="grey lighten-1" style="font-size:18px">
                                            mdi-information
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Programmatic tooltip</span>
                            </v-tooltip>
                        </label>
                        <v-radio-group v-model="sendInvoice" row>
                            <v-radio label="Yes" value="yes"></v-radio>
                            <v-radio label="No" value="no"></v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>







                <v-row>
                    <v-col cols="12">
                        <v-row>
                            <v-col cols="4">
                                <BarcodeScanner v-model="showBarcodeScanner" @passBarcodeNumber="getBarcodeNumber" />
                                <v-btn variant="outlined" block color="primary" @click="showBarcodeScanner=true">
                                    Add Item/ Inventory
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12">
                        <v-row>
                            <v-col cols="8">
                                <v-text-field outlined label="" v-model="barcodeNumber" placeholder="">
                                </v-text-field>
                            </v-col>
                            <v-col cols="4">
                                <v-btn x-large variant="outlined" block color="primary" @click="AddItem">
                                    Add
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols=12>
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">
                                            Item
                                        </th>
                                        <th class="text-left">
                                            MRP
                                        </th>
                                        <th class="text-left">
                                            Disc.
                                        </th>
                                        <th class="text-left">
                                            Tax
                                        </th>
                                        <th class="text-left">
                                            Quantity
                                        </th>
                                        <th class="text-left">
                                            Unit
                                        </th>
                                        <th class="text-left">
                                            Action
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in items" :key="index">
                                        <td>{{ item.name }}</td>
                                        <td>Rs. {{ item.mrp }}</td>
                                        <td>Rs. {{ item.discount_amount }}</td>
                                        <td>{{ item.tax }}</td>
                                        <td>
                                            <v-text-field type="number" step="any" min="1" ref="input"
                                                :rules="[numberRule]" v-model.number="item.quantity"></v-text-field>
                                        </td>
                                        <td>{{ item.unit }}</td>
                                        <td>
                                            <v-btn variant="outlined" color="error" @click="removeItem">
                                                Remove
                                            </v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col></v-col>
                </v-row>

            </v-container>
        </v-main>
        <Footer />
    </div>
</template>

<script>
    import Footer from '@/components/Footer.vue'
    import TopSearchBar from '@/components/TopSearchBar.vue'
    import BarcodeScanner from '@/components/barcode'

    export default {
        name: 'Preferences',
        components: {
            Footer,
            TopSearchBar,
            BarcodeScanner
        },
        data() {
            return {
                mobile_number: null,
                logo: null,
                // items: [{
                //     name: '',
                //     quantity: '',
                //     amount: 0,
                //     total: 0
                // }],
                items: [],
                showBarcodeScanner: false,
                barcodeNumber: '',
                sendInvoice: 'yes',
                customer_name: 'Cash'
            }
        },
        // watch: {
        //     'items': {
        //         handler(newValue) {
        //             newValue.forEach((item) => {
        //                 item.total = item.quantity * item.amount
        //             })
        //         },
        //         deep: true
        //     }
        // },
        methods: {
            AddItem() {

                let product = '';
                this.$store.dispatch('getProductByBarcodeNumber', this.barcodeNumber)
                    .then((res) => {
                        // console.log("getProductByBarcodeNumber",res.data.data)
                        product = res.data.data

                        this.items.push({
                            name: product.name,
                            mrp: product.mrp,
                            discount_amount: product.discount_amount,
                            tax: product.tax_percentage,
                            quantity: 1,
                            unit: product.base_unit,
                        })

                    })
                    .catch(err => {
                        console.log(err)
                    })


                // this.items.push({
                //     name: '',
                //     quantity: 0,
                //     amount: 0,
                //     total: 0
                // })
            },
            removeItem() {
                this.items.splice(this.items, 1)
            },
            getBarcodeNumber({
                barcodeNumber
            }) {
                this.barcodeNumber = barcodeNumber
            },
        }

    }
</script>

<style scoped>
</style>